import { incApi } from 'api/inc-api';

export const rtkQueryLogoutMiddleware = api => next => action => {
  if (incApi.endpoints.logout.matchFulfilled(action))
    api.dispatch(incApi.util.resetApiState());

  return next(action);
};
